import {
  // GET ADMINISTRATORS LIST
  GET_ADMINISTRATORS_LIST,
  GET_ADMINISTRATORS_LIST_SUCCESS,
  GET_ADMINISTRATORS_LIST_FAILED,

  // GET EXTRANET ADMINISTRATORS LIST
  GET_EXTRANET_ADMINISTRATORS_LIST,
  GET_EXTRANET_ADMINISTRATORS_LIST_SUCCESS,
  GET_EXTRANET_ADMINISTRATORS_LIST_FAILED,

  // GET ADMINISTRATORS DETAIL
  GET_ADMINISTRATORS_DETAIL,
  GET_ADMINISTRATORS_DETAIL_SUCCESS,
  GET_ADMINISTRATORS_DETAIL_FAILED,

  // ADD ADMINISTRATOR
  ADD_ADMINISTRATOR,
  ADD_ADMINISTRATOR_SUCCESS,
  ADD_ADMINISTRATOR_FAILED,

  // CREATE ADMINISTRATOR PASSWORD
  CREATE_ADMINISTRATOR_PASSWORD,
  CREATE_ADMINISTRATOR_PASSWORD_SUCCESS,
  CREATE_ADMINISTRATOR_PASSWORD_FAILED,

  // DELETE ADMINISTRATOR
  DELETE_ADMINISTRATOR,
  DELETE_ADMINISTRATOR_SUCCESS,
  DELETE_ADMINISTRATOR_FAILED,

  // EDIT ADMINISTRATOR
  EDIT_ADMINISTRATOR,
  EDIT_ADMINISTRATOR_SUCCESS,
  EDIT_ADMINISTRATOR_FAILED,

  // GET ACTION HISTORY LIST
  GET_ACTION_HISTORY_LIST,
  GET_ACTION_HISTORY_LIST_SUCCESS,
  GET_ACTION_HISTORY_LIST_FAILED,

  // GET MY PERMISSION
  GET_MY_PERMISSION,
  GET_MY_PERMISSION_SUCCESS,
  GET_MY_PERMISSION_FAILED,

  // GET EXTRANET ADMINISTRATORS PLACE MANAGER
  GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER,
  GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER_SUCCESS,
  GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER_FAILED,

  // EDIT EXTRANET ADMINISTRATOR
  EDIT_EXTRANET_ADMINISTRATOR,
  EDIT_EXTRANET_ADMINISTRATOR_SUCCESS,
  EDIT_EXTRANET_ADMINISTRATOR_FAILED,

  // DELETE EXTRANET ADMINISTRATOR
  DELETE_EXTRANET_ADMINISTRATOR,
  DELETE_EXTRANET_ADMINISTRATOR_SUCCESS,
  DELETE_EXTRANET_ADMINISTRATOR_FAILED,

  // RESET EXTRANET ADMINISTRATOR PASSWORD
  RESET_EXTRANET_ADMINISTRATOR_PASSWORD,
  RESET_EXTRANET_ADMINISTRATOR_PASSWORD_SUCCESS,
  RESET_EXTRANET_ADMINISTRATOR_PASSWORD_FAILED,

  // CHECK EXTRANET EMAIL
  CHECK_EXTRANET_EMAIL,
  CHECK_EXTRANET_EMAIL_SUCCESS,
  CHECK_EXTRANET_EMAIL_FAILED,

  // ADD EXTRANET ADMINISTRATOR
  ADD_EXTRANET_ADMINISTRATOR,
  ADD_EXTRANET_ADMINISTRATOR_SUCCESS,
  ADD_EXTRANET_ADMINISTRATOR_FAILED,

  RESET_INTRANET_ADMINISTRATOR_PASSWORD,
  RESET_INTRANET_ADMINISTRATOR_PASSWORD_SUCCESS,
  RESET_INTRANET_ADMINISTRATOR_PASSWORD_FAILED,
} from './actionTypes';

const initialState = {
  isLoadingGetAdministratorsList: false,
  isLoadingGetExtranetAdministratorsList: false,
  isLoadingGetAdministratorsDetail: false,
  isLoadingAddAdministrator: false,
  isLoadingCreateAdministratorPassword: false,
  isLoadingDeleteAdministrator: false,
  isLoadingEditAdministrator: false,
  isLoadingGetActionHistoryList: false,
  isLoadingGetMyPermission: false,

  administratorsList: [],
  extranetAdministratorsList: [],
  administratorsDetail: {},
  administratorsTotal: 0,
  extranetAdministratorsTotal: 0,
  actionHistoryList: [],
  myPermission: {},

  isLoadingGetExtranetAdministratorsPlaceManager: false,
  loadingExtranetAdministratorsPlaceManagerKey: null,
  extranetAdministratorsPlaceManager: [],

  isLoadingEditExtranetAdministrator: false,
  isLoadingDeleteExtranetAdministrator: false,

  isLoadingResetExtranetAdministratorPassword: false,
  isLoadingResetIntranetAdministratorPassword: false,

  isLoadingCheckExtranetEmail: false,
  checkExtranetEmailResult: null,

  isLoadingAddExtranetAdministrator: false,
};

export default function administrator(state = initialState, action) {
  switch (action.type) {
    // GET ADMINISTRATORS LIST
    case GET_ADMINISTRATORS_LIST:
      return {
        ...state,
        isLoadingGetAdministratorsList: true,
      };

    case GET_ADMINISTRATORS_LIST_SUCCESS:
      return {
        ...state,
        administratorsList: action.payload.append
          ? [...state.administratorsList, ...action.payload.data]
          : action.payload.data,
        administratorsTotal: action.payload.total,
        isLoadingGetAdministratorsList: false,
      };

    case GET_ADMINISTRATORS_LIST_FAILED:
      return {
        ...state,
        isLoadingGetAdministratorsList: false,
      };

    // GET EXTRANET ADMINISTRATORS LIST
    case GET_EXTRANET_ADMINISTRATORS_LIST:
      return {
        ...state,
        isLoadingGetExtranetAdministratorsList: true,
      };

    case GET_EXTRANET_ADMINISTRATORS_LIST_SUCCESS: {
      const newList = (action.payload.data || []).map((newItem) => {
        const existingItem = (state.extranetAdministratorsList || []).find(
          (oldItem) => oldItem._id === newItem._id && oldItem.place?._id === newItem.place?._id,
        );
        if (existingItem && existingItem.children) {
          return {
            ...newItem,
            children: existingItem.children,
          };
        }
        return newItem;
      });

      return {
        ...state,
        extranetAdministratorsList: action.payload.append
          ? [...state.extranetAdministratorsList, ...newList]
          : newList,
        extranetAdministratorsTotal: action.payload.total,
        isLoadingGetExtranetAdministratorsList: false,
      };
    }

    case GET_EXTRANET_ADMINISTRATORS_LIST_FAILED:
      return {
        ...state,
        isLoadingGetExtranetAdministratorsList: false,
      };

    // GET ADMINISTRATORS DETAIL
    case GET_ADMINISTRATORS_DETAIL:
      return {
        ...state,
        isLoadingGetAdministratorsDetail: true,
      };

    case GET_ADMINISTRATORS_DETAIL_SUCCESS:
      return {
        ...state,
        administratorsDetail: action.payload,
        isLoadingGetAdministratorsDetail: false,
      };

    case GET_ADMINISTRATORS_DETAIL_FAILED:
      return {
        ...state,
        isLoadingGetAdministratorsDetail: false,
      };

    // ADD ADMINISTRATOR
    case ADD_ADMINISTRATOR:
      return {
        ...state,
        isLoadingAddAdministrator: true,
      };

    case ADD_ADMINISTRATOR_SUCCESS:
      return {
        ...state,
        isLoadingAddAdministrator: false,
      };

    case ADD_ADMINISTRATOR_FAILED:
      return {
        ...state,
        isLoadingAddAdministrator: false,
      };

    // CREATE ADMINISTRATOR PASSWORD
    case CREATE_ADMINISTRATOR_PASSWORD:
      return {
        ...state,
        isLoadingCreateAdministratorPassword: true,
      };

    case CREATE_ADMINISTRATOR_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoadingCreateAdministratorPassword: false,
      };

    case CREATE_ADMINISTRATOR_PASSWORD_FAILED:
      return {
        ...state,
        isLoadingCreateAdministratorPassword: false,
      };

    // DELETE ADMINISTRATOR
    case DELETE_ADMINISTRATOR:
      return {
        ...state,
        isLoadingDeleteAdministrator: true,
      };

    case DELETE_ADMINISTRATOR_SUCCESS:
      return {
        ...state,
        isLoadingDeleteAdministrator: false,
      };

    case DELETE_ADMINISTRATOR_FAILED:
      return {
        ...state,
        isLoadingDeleteAdministrator: false,
      };

    // EDIT ADMINISTRATOR
    case EDIT_ADMINISTRATOR:
      return {
        ...state,
        isLoadingEditAdministrator: true,
      };

    case EDIT_ADMINISTRATOR_SUCCESS:
      return {
        ...state,
        isLoadingEditAdministrator: false,
      };

    case EDIT_ADMINISTRATOR_FAILED:
      return {
        ...state,
        isLoadingEditAdministrator: false,
      };

    // GET ACTION HISTORY LIST
    case GET_ACTION_HISTORY_LIST:
      return {
        ...state,
        isLoadingGetActionHistoryList: true,
      };

    case GET_ACTION_HISTORY_LIST_SUCCESS:
      return {
        ...state,
        actionHistoryList: action.payload,
        isLoadingGetActionHistoryList: false,
      };

    case GET_ACTION_HISTORY_LIST_FAILED:
      return {
        ...state,
        isLoadingGetActionHistoryList: false,
      };

      // GET MY PERMISSION
    case GET_MY_PERMISSION:
      return {
        ...state,
        isLoadingGetMyPermission: true,
      };

    case GET_MY_PERMISSION_SUCCESS:
      return {
        ...state,
        myPermission: action.payload,
        isLoadingGetMyPermission: false,
      };

    case GET_MY_PERMISSION_FAILED:
      return {
        ...state,
        isLoadingGetMyPermission: false,
      };

    // GET EXTRANET ADMINISTRATORS PLACE MANAGER
    case GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER:
      return {
        ...state,
        isLoadingGetExtranetAdministratorsPlaceManager: true,
        loadingExtranetAdministratorsPlaceManagerKey: action.payload?.rowKey || null,
      };

    case GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER_SUCCESS:
      return {
        ...state,
        extranetAdministratorsList: (state.extranetAdministratorsList || []).map((item) => {
          const itemKey = item.place?._id ? `${item._id}_${item.place._id}` : item._id;
          if (itemKey === action.payload.rowKey) {
            return {
              ...item,
              children: action.payload.data,
            };
          }
          return item;
        }),
        extranetAdministratorsPlaceManager: action.payload.data,
        isLoadingGetExtranetAdministratorsPlaceManager: false,
        loadingExtranetAdministratorsPlaceManagerKey: null,
      };

    case GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER_FAILED:
      return {
        ...state,
        isLoadingGetExtranetAdministratorsPlaceManager: false,
        loadingExtranetAdministratorsPlaceManagerKey: null,
      };

    // EDIT EXTRANET ADMINISTRATOR
    case EDIT_EXTRANET_ADMINISTRATOR:
      return {
        ...state,
        isLoadingEditExtranetAdministrator: true,
      };

    case EDIT_EXTRANET_ADMINISTRATOR_SUCCESS:
      return {
        ...state,
        isLoadingEditExtranetAdministrator: false,
      };

    case EDIT_EXTRANET_ADMINISTRATOR_FAILED:
      return {
        ...state,
        isLoadingEditExtranetAdministrator: false,
      };

    // DELETE EXTRANET ADMINISTRATOR
    case DELETE_EXTRANET_ADMINISTRATOR:
      return {
        ...state,
        isLoadingDeleteExtranetAdministrator: true,
      };

    case DELETE_EXTRANET_ADMINISTRATOR_SUCCESS:
      return {
        ...state,
        isLoadingDeleteExtranetAdministrator: false,
      };

    case DELETE_EXTRANET_ADMINISTRATOR_FAILED:
      return {
        ...state,
        isLoadingDeleteExtranetAdministrator: false,
      };

    // RESET EXTRANET ADMINISTRATOR PASSWORD
    case RESET_EXTRANET_ADMINISTRATOR_PASSWORD:
      return {
        ...state,
        isLoadingResetExtranetAdministratorPassword: true,
      };

    case RESET_EXTRANET_ADMINISTRATOR_PASSWORD_SUCCESS:
    case RESET_EXTRANET_ADMINISTRATOR_PASSWORD_FAILED:
      return {
        ...state,
        isLoadingResetExtranetAdministratorPassword: false,
      };

    // RESET INTRANET ADMINISTRATOR PASSWORD
    case RESET_INTRANET_ADMINISTRATOR_PASSWORD:
      return {
        ...state,
        isLoadingResetIntranetAdministratorPassword: true,
      };

    case RESET_INTRANET_ADMINISTRATOR_PASSWORD_SUCCESS:
    case RESET_INTRANET_ADMINISTRATOR_PASSWORD_FAILED:
      return {
        ...state,
        isLoadingResetIntranetAdministratorPassword: false,
      };

    // CHECK EXTRANET EMAIL
    case CHECK_EXTRANET_EMAIL:
      return {
        ...state,
        isLoadingCheckExtranetEmail: true,
        checkExtranetEmailResult: null,
      };

    case CHECK_EXTRANET_EMAIL_SUCCESS:
      return {
        ...state,
        isLoadingCheckExtranetEmail: false,
        checkExtranetEmailResult: action.payload,
      };

    case CHECK_EXTRANET_EMAIL_FAILED:
      return {
        ...state,
        isLoadingCheckExtranetEmail: false,
        checkExtranetEmailResult: null,
      };

    // ADD EXTRANET ADMINISTRATOR
    case ADD_EXTRANET_ADMINISTRATOR:
      return {
        ...state,
        isLoadingAddExtranetAdministrator: true,
      };

    case ADD_EXTRANET_ADMINISTRATOR_SUCCESS:
      return {
        ...state,
        isLoadingAddExtranetAdministrator: false,
      };

    case ADD_EXTRANET_ADMINISTRATOR_FAILED:
      return {
        ...state,
        isLoadingAddExtranetAdministrator: false,
      };

    default:
      return state;
  }
}
